// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { InstrumentId } from '@daml.js/splice-api-token-holding-v1-1.0.0/lib/Splice/Api/Token/HoldingV1';
import { BridgeUserAgreementRequest } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/User/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRequestBridgeUserAgreement: () => UseMutationResult<
  ContractId<BridgeUserAgreementRequest>,
  string,
  {
    crossChainRepresentative: string;
    operator: string;
    bridgeOperator: string;
    user: string;
    instrumentId: InstrumentId;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['requestBridgeUserAgreement', ledgerApi],
    mutationFn: async ({
      crossChainRepresentative,
      operator,
      bridgeOperator,
      user,
      instrumentId,
    }) => {
      const createEvent = await ledgerApi.requestBridgeUserAgreement(
        crossChainRepresentative,
        operator,
        bridgeOperator,
        user,
        instrumentId,
      );
      return createEvent.contractId;
    },
  });
};

export default useRequestBridgeUserAgreement;
